import { queryOptions } from "@tanstack/react-query";

import {
  getMyClientRevenueEstimateFn,
  getMyReadinessFn,
} from "~/lib/functions/readiness";

export const MY_READINESS_QUERY_KEY = ["readiness", "mine"] as const;

/** Her completed 6-Figure Readiness Scores, newest first, and the rerun date. */
export const myReadinessQueryOptions = () =>
  queryOptions({
    queryKey: MY_READINESS_QUERY_KEY,
    queryFn: () => getMyReadinessFn(),
    staleTime: 60 * 1000,
  });

/** Paying clients times typical price from her coach intake, or null without one. */
export const myClientRevenueEstimateQueryOptions = () =>
  queryOptions({
    queryKey: ["coach-intake", "client-revenue"] as const,
    queryFn: () => getMyClientRevenueEstimateFn(),
    staleTime: 60 * 1000,
  });
